import '../styles/cta/two.scss'

const CTATwo = () => {
  return (
    <div className="cta__two__container">
        <div className="cta__two__wrapper">

            <span className='cta__two__texts'>
            <h1 className='cta__two__text'>Join the team of our experienced traders</h1>
            <p className='cta__two__supporting__text'>It’s easy to get started. Sign up today to start trading with us.</p>
            </span>


            <span className='cta__two__buttons'>
                <button className='cta__two__button__blue'>Get Started</button>
            </span>

        </div>
    </div>
  )
}

export default CTATwo